// let $ = require('jquery');
// import {globalConfig} from '@/utils/config'
import request from '../../utils/request'

const state = {
    httpServer: "http://192.168.1.92:9501", //http://localhost:8888",  //服务端ip
    // httpOauth: "http://pb.tipdm.net/tipdm-oauth2", //http://localhost:8082/oauth",  //授权服务ip
    // httpClient: "http://localhost:8087", //http://localhost:8080",  //客户端ip
    userInfo: {
        username: ""
    },
    exceptionDeal: {
        overtime: false, //是否超时，默认否401
        otherException: false,//其它异常405
        exceptionMessage: "",//后台返回异常信息
    },//异常信息处理
    // 前端页面不需要显示字段
    frontIgnoredFields: [],
    textConfig: {},
    isConfirmInfo: false
}

const actions = {
    // ajax({commit}, payload) {
    //     const isDev = process.env.NODE_ENV !== 'production';
    //     return new Promise((resolve, reject) => {
    //         $.ajax({
    //             url: isDev ? globalConfig.VUE_APP_BASE_API + payload.url : payload.url,
    //             type: payload.method ? payload.method : "get",
    //             dataType: "json",
    //             data: payload.data ? payload.data : {},
    //             async: payload.asynch ? payload.asynch : true,
    //             contentType: "application/json; charset=utf-8",
    //             beforeSend: function (XMLHttpRequest) {
    //                 XMLHttpRequest.setRequestHeader("accessToken", localStorage.accessToken);
    //             },
    //             success: function (data) {
    //                 if (data.status == "SUCCESS") {
    //                     resolve(data);
    //                 } else if (data.status == "FAIL") {
    //                     commit("dealRequestError", data);
    //                     reject(data);
    //                 }
    //             },
    //             error: function (xhr) {
    //                 commit("dealRequestError", xhr);
    //                 reject(xhr);
    //             }
    //         });
    //     });
    // },
    getTokenInfo(payload) {
        return new Promise((resolve)=>{
            request({
                url: "/token/info",
                asynch: payload.asynch
            }).then((data)=>{
                resolve(data);
            })
        })
    },

    // 获取前端页面不需要显示的字段
    getFrontIgnoredFields({state}) {
        return new Promise(() => {
            request({
                url: `/api/certInfo/frontIgnoredFields`,
                method: 'get'
            }).then(data => {
                state.frontIgnoredFields = data.data;
            })
        })
    },
}

const mutations = {
    dealRequestError(state, payload) {
        switch (payload.status) {
            case 401://超时
                state.exceptionDeal.overtime = true;
                break;
            case 403://无权限
                state.exceptionDeal.otherException = false;
                break;
            case 404://接口找不到
                state.exceptionDeal.otherException = true;
                break;
            case 405://其它异常
                state.exceptionDeal.otherException = true;
                break;
            case 500://500
                state.exceptionDeal.otherException = true;
                break;
            case "FAIL":
                if (payload.data == "401") {
                    state.exceptionDeal.overtime = true;
                    state.exceptionDeal.exceptionMessage = payload.message;
                } else {
                    state.exceptionDeal.otherException = true;
                    state.exceptionDeal.exceptionMessage = payload.message;
                }
                break;
        }
        if (payload.responseJSON) {
            state.exceptionDeal.exceptionMessage = payload.responseJSON.message;
        } else if (payload.responseText) {
            state.exceptionDeal.exceptionMessage = JSON.parse(payload.responseText).message;
        }
    }
}

export default {
    state,
    actions,
    mutations
}
